export const calculateCreatorLevel = (stats) => {
  const { skills = 0, rating = 0, sales = 0 } = stats || {};

  if (stats.skills >= 11 && stats.rating >= 4.5 && stats.sales >= 200) return "Diamond";
  if (stats.skills >= 6 && stats.rating >= 4.3 && stats.sales >= 50) return "Gold";
  if (stats.skills >= 3 && stats.rating >= 4.0 && stats.sales >= 10) return "Silver";
  return "Bronze";
};

export const calculateEarnings = (skills) => {
  if (!skills || !Array.isArray(skills)) return { total: 0, byMonth: [] };
  const total = skills.reduce((sum, s) => sum + (s.price || 0) * (s.sales || 0), 0);
  return {
    total,
    byMonth: [
      { month: "January", value: total * 0.15 },
      { month: "February", value: total * 0.18 },
      { month: "March", value: total * 0.22 },
      { month: "April", value: total * 0.25 },
      { month: "May", value: total * 0.20 },
    ],
  };
};

export const getCreatorBadges = (stats) => {
  const badges = [];
  if (stats.sales >= 100) badges.push({ id: "top_seller", name: "Top Seller", icon: "🏆" });
  if (stats.rating >= 4.8) badges.push({ id: "highly_rated", name: "Highly Rated", icon: "⭐" });
  if (stats.skills >= 10) badges.push({ id: "prolific", name: "Prolific Creator", icon: "🚀" });
  if (stats.skills >= 1 && stats.rating >= 4.0 && stats.sales >= 1) badges.push({ id: "verified", name: "Verified Creator", icon: "✓" });
  return badges;
};

export const getNextLevelRequirement = (stats) => {
  const level = calculateCreatorLevel(stats);
  if (level === "Diamond") return { next: null, message: "You have reached the maximum level!" };
  if (level === "Gold") return { next: "Diamond", requirements: { skills: 11, rating: 4.5, sales: 200 } };
  if (level === "Silver") return { next: "Gold", requirements: { skills: 6, rating: 4.3, sales: 50 } };
  return { next: "Silver", requirements: { skills: 3, rating: 4.0, sales: 10 } };
};
